module.exports = __webpack_public_path__ + "static/websitecarbon-45616470f3922870604ac2ce2d4bdfdf.png";